import React from "react";
import { Context } from "../types";

interface ContextModalProps {
  isOpen: boolean;
  isEdit: boolean;
  context: Context | null;
  onSave: () => void;
  onCancel: () => void;
  onArchive: (id: number) => void;
  onDelete: (id: number) => void;
  onContextChange: (context: Context) => void;
}

export const ContextModal: React.FC<ContextModalProps> = ({
  isOpen,
  isEdit,
  context,
  onSave,
  onCancel,
  onArchive,
  onDelete,
  onContextChange,
}) => {
  if (!isOpen || !context) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        zIndex: 1000,
        animation: "fadeIn 0.1s ease-out forwards",
        overflowY: "auto",
        padding: "20px 0"
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "24px",
          borderRadius: "16px",
          width: "90%",
          maxWidth: "400px",
          margin: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <h3 style={{
          fontSize: "20px",
          fontWeight: 600,
          marginBottom: "24px",
          color: "#000"
        }}>
          {isEdit ? "Edit Context" : "Add Context"}
        </h3>

        <input
          type="text"
          placeholder="Name"
          value={context.name || ""}
          onChange={(e) => onContextChange({ ...context, name: e.target.value })}
          style={{
            width: "100%",
            padding: "12px 16px",
            marginBottom: "16px",
            borderRadius: "12px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            color: "#000",
            fontSize: "16px",
            outline: "none",
          }}
        />

        <input
          type="color"
          value={context.color || "#6c5ce7"}
          onChange={(e) => onContextChange({ ...context, color: e.target.value })}
          style={{
            width: "100%",
            height: "50px",
            padding: "8px",
            marginBottom: "24px",
            borderRadius: "12px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            cursor: "pointer",
          }}
        />

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "24px" }}>
          {isEdit && (
            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={() => onArchive(context.id)}
                style={{
                  flex: 1,
                  padding: "14px",
                  backgroundColor: context.archived ? "#28a745" : "#ffc107",
                  color: "#fff",
                  border: "none",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                {context.archived ? "Unarchive" : "Archive"}
              </button>
              {context.archived && (
                <button
                  onClick={() => onDelete(context.id)}
                  style={{
                    flex: 1,
                    padding: "14px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          )}

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={onCancel}
              style={{
                flex: 1,
                padding: "14px",
                backgroundColor: "#6c757d",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={!context.name}
              style={{
                flex: 1,
                padding: "14px",
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                cursor: !context.name ? "not-allowed" : "pointer",
                opacity: !context.name ? 0.5 : 1,
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};